<div class="dialog-root">
  <h2>How should we process your documents?</h2>
  <p class="muted">Choose how uploaded files are organized when you drop multiple documents at once.</p>

  <div class="processing-options">
    <div class="option-card" (click)="choose('separate')">
      <div class="icon-box"><img src="./../../../../assets/images/separate-documents.png" height="30" alt="Separate Icon"></div>
      <div class="option-body">
        <strong>Create Separate Records</strong>
        <div class="muted">Each document creates its own individual record.</div>
      </div>
    </div>

    <div class="option-card" (click)="choose('merge')">
      <div class="icon-box"><img src="./../../../../assets/images/merge-documents.png" height="30" alt="Merge Icon"></div>
      <div class="option-body">
        <strong>Combine Into One Record</strong>
        <div class="muted">All documents are grouped into one unified record.</div>
      </div>
    </div>
  </div>

  <div class="modal-actions">
    <button mat-button (click)="cancel()">Cancel</button>
    <!-- <button mat-flat-button color="primary" (click)="continue()">Continue</button> -->
  </div>
</div>
